var stockBaseInfoStore = {
    state: () => ({
        stocks: {}
    }),

    mutations: {
        setStocks(state, { stocks }) {
            state.stocks = stocks
        },

        addStockInfo(state, { stock }) {
            if (!state.stocks[stock.id] && stock.symbol) {
                state.stocks[stock.id] = stock
            }
        }
    },

    actions: {
        setStocks(context, { stocks }) {
            context.commit('setStocks', { stocks })
        },

        addStockInfo(context, { stock }) {
            context.commit('addStockInfo', { stock })
        }
    },

    getters: {
        getStocks(state) {
            return state.stocks
        },

        getStockInfoById: (state) => (id) => {
            return state.stocks[id]
        }
    }

}

export default stockBaseInfoStore